module.exports = __webpack_public_path__ + "static/img/ikona_cw2-ON.64ad5fb9.png";